// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ogMf","image":"Header_image__32amw","name":"Header_name__3qZhv","info":"Header_info__9PORl","infoRow":"Header_infoRow__1gZgt"};